<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <Form ref="inscriptionForm" @submit="editInscription" :validation-schema="inscriptionSchema" :initial-values="inscriptionForm">
            <div class="row">
              <div class="col-md-6">
                      <label for="titre" class="form-label">Titre<span class="text-danger">*</span></label>
                      <Field name="titre" class="form-control" type="text"/>
                      <ErrorMessage name="titre" class="text-danger" />
              </div>
              <div class="col-md-6">
                      <label for="anneePublication" class="form-label">Année Publication<span class="text-danger">*</span></label>
                      <Field name="anneePublication" class="form-control" type="text"/>
                      <ErrorMessage name="anneePublication" class="text-danger" />
              </div>
          
              <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black mb-10">
                  Catégorie <span class="text-danger">*</span>
                </label>
                <Field name="categorie" v-model="categories" type="text" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" :options="categorieOptions" :preserve-search="true"
                   :multiple="false" :searchable="true" placeholder="Sélectionner la catégorie"
                  label="label" track-by="label" />
                </Field>
                <span class="text-danger" v-if="showMErr">La catégorie est obligatoire</span>
              </div>
            </div>
  
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black mb-10">
                 Maison d'Edition <span class="text-danger">*</span>
                </label>
                <Field name="maisonEdition" type="text" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" :options="maisonEditionOptions" :preserve-search="true"
                   :multiple="false" :searchable="true" placeholder="Sélectionner la maison d'Edition"
                  label="label" track-by="label" />
                </Field>
                <ErrorMessage name="maisonEdition" class="text-danger" />
              </div>
            </div>

              
          <div class="col-md-12 d-flex flex-column mt-3">
            <div class="d-flex align-items-center ">
              <button
                class="btn btn-success me-3"
                type="submit"
              >
                  Modifier Inscription
              </button>
              <router-link to="/inscriptions/liste-inscription" 
                  class=" btn btn-danger"><i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                  <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
  </template>
  

  <script lang="ts">
  import { defineComponent, ref, onMounted } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import { error, success } from '@/utils/utils';
  import { useRoute, useRouter } from 'vue-router';
  import ApiService from '@/services/ApiService';
  
  import * as Yup from 'yup';
  import axios from 'axios';
  import Multiselect from '@vueform/multiselect'
import { Inscription } from '@/models/Inscription';
  
  export default defineComponent({
      name: "EditInscription",
      components: {
      Form,
      Field,
      ErrorMessage,
      Multiselect
    },
    setup: () => {
      const inscriptionSchema = Yup.object().shape({
              titre: Yup.string().required("La référence est obligatoire."),
              anneePublication: Yup.string().required("Le libelle est obligatoire."),   
              categorie: Yup.string().required("La catégorie est obligatoire."),
              maisonEdition: Yup.string().required("La maison d'Edition est obligatoire."),

      });
  
      const inscriptionForm = ref<Inscription>();
        const showMErr = ref(false);
        const categories = ref();
        const maisonEditionOptions = ref();
        const categorieOptions = ref([]);
      const router = useRouter();
      const route = useRoute();
  
      onMounted(() => {
        getAllMaisonEditions();
        getAllCategories();
        if(route.params.id) {
          getInscription(parseInt(route.params.id as string));
        }
      });
  
  
      function getInscription(id:number) {
        ApiService.get("/inscriptions/"+id.toString())
          .then(({ data }) => {
            for (const key in data.data) {
              inscriptionForm.value?.setFieldValue(key, 
              (typeof data.data[key] === 'object' && data.data[key] !== null)? data.data[key].id :data.data[key]
            );
            }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
      }
      
      const getAllMaisonEditions = async () => {
            try{
            const response = await ApiService.get('/all/maisonEditions');
            const maisonEditionData = response.data.data.data;
            console.log('Data', maisonEditionData)
            maisonEditionOptions.value = maisonEditionData.map((maisonEdition) => ({
              value: maisonEdition.id,
              label: maisonEdition.nom,
            }));
            }
            catch(error){
              //error(response.data.message)
            }
          }
          const getAllCategories= async () => {
            try{
            const response = await ApiService.get('/all/categories');
            const categoriesData = response.data.data.data;
            categorieOptions.value = categoriesData.map((categorie) => ({
              value: categorie.id,
              label: categorie.nom,
            }));
            }
            catch(error){
              //error(response.data.message)
            }
          } 
  
  
  const editInscription = async (values, { resetForm }) => {
    try {
      const response = await ApiService.put(`/inscriptions/${values.id}`, values);
      
      if (response.status === 200) {
        success(response.data.message);
        resetForm();
        router.push({ name: "ListeInscriptionPage" });
      }
    } catch (err) {
      console.log(err);
      // error(err.response?.data?.message || "Une erreur est survenue.");
    }
  };
      return { 
        inscriptionSchema, editInscription, inscriptionForm,categories,maisonEditionOptions,categorieOptions,showMErr
      };
    },
  });
  </script>